import moment from 'moment';
import React, { useMemo } from 'react';

import { AnyTransactionPeriod, TransactionPeriod } from '@/model/wallets/types';

interface TransactionFilterTitlePeriodProps {
  'data-test'?: string;
  value: AnyTransactionPeriod;
}

const dateFormat = 'DD.MM.YYYY';

const TransactionFilterTitlePeriod: React.FC<TransactionFilterTitlePeriodProps> = ({
  value,
  'data-test': dataTest,
}) => {
  const dateFrom = useMemo(() => {
    switch (value.type) {
      case TransactionPeriod.lastWeek:
        return moment()
          .subtract(1, 'week')
          .format(dateFormat);
      case TransactionPeriod.lastMonth:
        return moment()
          .subtract(1, 'month')
          .format(dateFormat);
      case TransactionPeriod.last3Month:
        return moment()
          .subtract(3, 'month')
          .format(dateFormat);
      case TransactionPeriod.custom:
        return moment(value.dateFrom).format(dateFormat);
      default:
        return null;
    }
  }, [value]);
  const dateTo = useMemo(() => {
    switch (value.type) {
      case TransactionPeriod.lastWeek:
      case TransactionPeriod.lastMonth:
      case TransactionPeriod.last3Month:
        return moment().format(dateFormat);
      case TransactionPeriod.custom:
        return moment(value.dateTo).format(dateFormat);
      default:
        return null;
    }
  }, [value]);
  return dateFrom && dateTo ? (
    <span data-test={dataTest}>
      {dateFrom} - {dateTo}
    </span>
  ) : null;
};

export default React.memo(TransactionFilterTitlePeriod);
